module.exports = __webpack_public_path__ + "img/美術館.cb4a8921.jpg";